/**
 * Gelly preloader — hide after load with minimum display time
 */
(function () {
  if (window.Shopify && window.Shopify.designMode) return;

  function init() {
    var preloader = document.getElementById('GellyPreloader');
    if (!preloader) return;

    var html = document.documentElement;
    var minTime = 700;
    var start = Date.now();
    var done = false;

    html.classList.add('gelly-preloader-active');

    function unlockScroll() {
      html.classList.remove('gelly-preloader-active');
    }

    function hide() {
      if (done) return;
      done = true;
      unlockScroll();
      preloader.classList.add('is-hidden');
      preloader.setAttribute('aria-hidden', 'true');
      window.setTimeout(function () {
        if (preloader.parentNode) preloader.parentNode.removeChild(preloader);
      }, 600);
    }

    function tryHide() {
      var elapsed = Date.now() - start;
      var wait = Math.max(0, minTime - elapsed);
      window.setTimeout(hide, wait);
    }

    if (document.readyState === 'complete') {
      tryHide();
    } else {
      window.addEventListener('load', tryHide, { once: true });
      window.setTimeout(tryHide, 3500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
